<template>
  <div class="description">
    <div class="notice-line">
      <p :style="{visibility: lastUpdateDateTime ? 'visible' : 'hidden'}" class="last-update">最終更新日時：{{ lastUpdateDateTime }}</p>
      <div class="share" v-if="!isWV">
        <span><a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-url="https://covid19.unerry.jp/" data-show-count="false">Tweet</a></span>
        <span><div class="fb-share-button" data-href="https://covid19.unerry.jp" data-layout="button_count" data-size="small"><a target="_blank" href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcovid19.unerry.jp%2F&amp;src=sdkpreparse" class="fb-xfbml-parse-ignore">シェア</a></div></span>
        <span><div class="line-it-button" data-lang="ja" data-type="share-a" data-ver="3" data-url="https://covid19.unerry.jp/" data-color="default" data-size="small" data-count="false" style="display: none;"></div></span>
        <span><a href="https://b.hatena.ne.jp/entry/s/covid19.unerry.jp/" class="hatena-bookmark-button" data-hatena-bookmark-layout="basic-label" data-hatena-bookmark-lang="ja" title="このエントリーをはてなブックマークに追加"><img src="https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png" alt="このエントリーをはてなブックマークに追加" width="20" height="20" style="border: none;" /></a></span>
      </div>
    </div>
    <span class="spacer" :class="{'is-wv': isWV}"></span>
    <div class="baloon" v-if="!isWV">
      <h2>「お買物混雑マップ 」って？</h2>
      <span>Powered by Beacon Bank</span>
    </div>
    <p v-if="620 < windowWidth" class="summary">日用品お買物時に、<br>スーパーやドラッグストア等のお店近辺の曜日・時間帯別混雑傾向が調べられます。<br>「密」を避ける行動のための参考情報としてご利用ください。</p>
    <p v-else class="summary">日用品お買物時に、<br>スーパーやドラッグストア等のお店近辺の<br>曜日・時間帯別混雑傾向が調べられます。<br>「密」を避ける行動のための<br>参考情報としてご利用ください。</p>
    <div class="detail">
      <div class="detail-item">
        <h3><span>お店の近辺の<br>混雑状況がわかります</span></h3>
        <p>スマートフォンの位置情報（GPS）を元に、お店近辺約100mの混雑状況をAI解析しています。（全てのお店を網羅的に記載するものではありません。）</p>
      </div>
      <div class="detail-item">
        <h3><span>混雑の基準は店舗エリアごとに<br>設定されています</span></h3>
        <p>直近4週間の中で最も混雑している1時間あたりの人数を100%の基準とし、時間帯ごとに「いつもより空いている」、「通常程度」、「通常より混雑」に分類しています。</p>
      </div>
      <div class="detail-item">
        <h3><span>店舗の営業有無 / 時間は<br>考慮されていません</span></h3>
        <p>店舗ごとの営業状況は事態に応じて変更の可能性があり、周辺の混雑状況も加味しているため、営業外の時間も表示されています。</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapGetters } from 'vuex'
import '@/assets/styles/social-button.override.scss'

export default defineComponent({
  name: 'Description',
  computed: {
    ...mapState(['windowWidth']),
    ...mapGetters(['lastUpdateDateTime', 'isWV']),
  },
  mounted () {
    try {
      window.LineIt && typeof window.LineIt.loadButton === 'function' && window.LineIt.loadButton()
      window.twttr && window.twttr.widgets && typeof window.twttr.widgets.load === 'function' && window.twttr.widgets.load()
      window.FB && window.FB.XFBML && typeof window.FB.XFBML.parse === 'function' && window.FB.XFBML.parse()
    } catch (e) {
      console.log(e)
    }
  }
})
</script>

<style scoped lang="scss">
.description {
  position: relative;

  .notice-line {
    position: absolute;
    top: 1px;
    right: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;

    p {
      display: block;
      margin: 10px 0 0 20px;
      color: #D13E3E;
      font-size: 14px;
      font-weight: bold;
      line-height: 14px;
      background-color: #FFF0F0;
      white-space: nowrap;
    }

    .share {
      margin-top: 10px;
      padding: 0 10px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      > span {
        display: inline-block;
        margin-left: 6px;
        &:nth-child(2) {
          margin-left: 7px;
        }
      }
    }
  }

  .spacer {
    display: block;
    height: 93px;

    &.is-wv {
      height: 35px;
    }
  }
  .baloon {
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    background-image: url(@/assets/images/balloon-pc.svg);
    width: 640px;
    height: 96px;

    h2 {
      margin: 0;
      padding-top: 15px;
      font-size: 28px;
      font-weight: bold;
      line-height: 28px;
      color: #fff;
    }

    span {
      display: block;
      margin-top: 7px;
      font-size: 13px;
      line-height: 13px;
      color: #fff;
    }
  }
  .summary {
    margin: 10px auto 0;
    line-height: 32px;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
  }
  .detail {
    margin-top: 41px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    &-item {
      margin: 0 15px 18px;

      h3 {
        margin: 0;
        width: 320px;
        height: 80px;
        line-height: 80px;
        font-size: 18px;
        text-align: center;
        background-color: #E4E9EF;

        span {
          display: inline-block;
          line-height: 26px;
          vertical-align: middle;
        }
      }

      p {
        margin: 10px 0 0 ;
        font-size: 16px;
        line-height: 28px;
        color: #000;

        width: 320px;
        height: 121px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .description {
    .baloon {
      background-size: 100% 100%;
      background-image: url(@/assets/images/balloon-sp.svg);
      width: 335px;
      height: 86px;

      h2 {
        padding-top: 13px;
        font-size: 20px;
        line-height: 20px;
      }

      span {
        margin-top: 7px;
        font-size: 12px;
        line-height: 12px;
        font-weight: bold;
      }
    }
    .summary {
      margin: 10px auto 0;
      line-height: 28px;
      font-size: 16px;
    }
    .detail {
      margin-top: 25px;

      &-item {
        margin: 0 15px 30px;

        h3 {
          font-size: 16px;
          max-width: 335px;
          width: calc(100vw - 40px);
        }

        p {
          max-width: 335px;
          width: calc(100vw - 40px);
          height: auto;
          font-size: 15px;
        }
      }
    }
  }
}

@media screen and (max-width: 374px) {
  .description {
    .baloon {
      width: 280px;

      h2 {
        padding-top: 19px;
        font-size: 18px;
        line-height: 18px;
      }

      span {
        margin-top: 3px;
        font-size: 10px;
        line-height: 10px;
      }
    }
  }
}

@media screen and (max-width: 620px) {
  .description {
    .notice-line {
      justify-content: center;
    }

    .spacer {
      &.is-wv {
        height: 40px;
      }
    }
  }
}
</style>
